import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getProgramBookDownloads(params: any): AxiosPromise {
    return EndPointService.get('/program_book_downloads', { params });
}

function getProgramBookDownload(id: number | string): AxiosPromise {
    return EndPointService.get(`/program_book_downloads/${id}`);
}

function deleteProgramBookDownload(id: number | string): AxiosPromise {
    return EndPointService.delete(`/program_book_downloads/${id}`);
}

function createProgramBookDownload(payload: any): AxiosPromise {
    return EndPointService.post('/program_book_downloads', payload);
}

export default {
    getProgramBookDownloads,

    getProgramBookDownload,
    deleteProgramBookDownload,
    createProgramBookDownload,
};
